<template>
  <div>
    <div class="trade-order-block">
      <div class="block-title">
        <span>请选择TRcode</span>
        <!-- <span class="block-radio" v-if="tradeApplyOrderVO.applyType !== '03'" @change="budgetTypeChange">
          <el-radio-group v-model="budgetType">
            <el-radio :label="0">TR预算</el-radio>
            <el-radio :label="1">其它预算</el-radio>
          </el-radio-group>
        </span> -->
      </div>
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">{{ budgetType ? '其它预算' : 'TRcode' }}</el-col>
          <el-col :span="9">
            <!-- tr预算 -->
            <el-select v-show="!budgetType" v-model="trCode" placeholder="请选择TRcode" size="small" clearable filterable style="width: 300px" @change="trChange">
              <!-- <el-option v-for="item in trList" :key="item.quotaId" :label="`${item.trKhCode}-${item.orgName}-${item.availableQuota}`" :value="item.quotaId" /> -->
              <el-option v-for="item in trList" :key="item.trKhCode" :label="`${item.trKhCode}`" :value="item.trKhCode" />
            </el-select>
            <!-- 其它预算 -->
            <el-select v-show="budgetType" v-model="approvalFormData.quotaId" placeholder="请选择预算" size="small" clearable filterable style="width: 300px">
              <el-option v-for="item in budgetList" :key="item.quotaDTO.quotaId" :label="item.quotaDTO.quotaName" :value="item.quotaDTO.quotaId" />
            </el-select>
          </el-col>
          <el-col :span="3">MMR12</el-col>
          <el-col :span="9">
            <el-select v-model="approvalFormData.mmr12" placeholder="请选择MMR12" size="small" clearable filterable style="width: 300px" @change="mmr12Change">
              <el-option v-for="item in mmrList" :key="item.mmr12Code" :label="item.mmr12Name" :value="item.mmr12Code" />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">所属工厂</el-col>
          <el-col :span="9">
            <el-select 
              v-model="approvalFormData.companyEntityCode" 
              placeholder="请选择所属工厂" 
              size="small" 
              clearable 
              filterable 
              style="width: 300px"
              @change="handleCompanyChange"
            >
              <el-option 
                v-for="item in companyList" 
                :key="item.entityCode" 
                :label="item.title" 
                :value="item.entityCode" 
              />
            </el-select>
          </el-col>
          <el-col :span="3">成本中心</el-col>
          <el-col :span="9">
            <el-select v-model="approvalFormData.costCenterCode" placeholder="请选择成本中心" size="small" clearable filterable style="width: 300px">
              <el-option v-for="item in costList" :key="item.costCenterCode" :label="item.costCenterName" :value="item.costCenterCode" />
            </el-select>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">总账科目</el-col>
          <el-col :span="9">
            <el-select v-model="approvalFormData.ledgerAccount" placeholder="请选择总账科目" size="small" clearable filterable style="width: 300px">
              <el-option v-for="item in ledgerList" :key="item.ledgerAccountCode" :label="`${item.ledgerAccountCode} - ${item.ledgerAccountName}`" :value="item.ledgerAccountCode" />
            </el-select>
          </el-col>
          <el-col :span="3">业务月份</el-col>
          <el-col :span="9">
            <el-date-picker value-format="yyyy-MM" style="width:300px;" v-model="approvalFormData.budgetMonth" type="month"
                  placeholder="选择月" size="mini" :picker-options="pickerMothOptions">
                </el-date-picker>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { parseTime } from '@/filters'
export default {
  name: 'order-budget-select',
  props: {
    tradeApplyOrderVO: {},
    approvalFormData: {},
    budgetSelectShow:{
      type:Boolean,
      type:false
    }
  },
  data () {
    return {
      budgetType: 0,

      budgetList: [],
      trList: [],
      mmrList: [],
      ledgerList: [],
      companyList: [],
      costList: [],
      trCode: '',

      pickerMothOptions: {
        disabledDate: (time) => {
          const beginDate = new Date().getTime()
          if(beginDate > time.getTime()){
            return  parseTime(beginDate,'{y}-{m}-{d}') !== parseTime(time,'{y}-{m}-{d}')
          }else{
            return false
          }
        },
      },
    }
  },
  watch: {
    tradeApplyOrderVO () {
      this.init()
    }
  },

  methods: {

    init () {
      this.getBudgetList()
      this.getTrList()
      this.getMmrList()
      this.getCompanyList()
      if (this.budgetSelectShow) {
        this.$set(this.approvalFormData, 'budgetMonth', parseTime(new Date(), '{y}-{m}'))
      }
    },

    budgetTypeChange () {
      this.approvalFormData.trCode = ''
      this.approvalFormData.quotaId = ''
    },

    // 获取普通预算
    getBudgetList () {
      const params = {
        quotaType: '01'
      }
      this.$store.dispatch('getBudgetList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.budgetList = res.data.resultData.quotaDetailList
        }
      })
    },

    // 获取TR预算
    getTrList () {
      const params = {
        applyId: this.tradeApplyOrderVO.applyId
      }
      this.$store.dispatch('getTrList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.trList = res.data.resultData.quotaList
        }
      })
    },

    trChange (val) {
      if (!val) {
        return
      }
      this.approvalFormData.trCode = val
      // this.approvalFormData.quotaId = val
      // this.trList.forEach(item => {
      //   if (item.quotaId === val) {
      //     this.approvalFormData.trCode = item.trKhCode
      //   }
      // })
    },

    // 获取MMR12
    getMmrList () {
      this.$store.dispatch('getMmrList').then(res => {
        if (res.data.resultCode === '0') {
          this.mmrList = res.data.resultData.baseMmr12List
        }
      })
    },

    mmr12Change () {
      this.ledgerList = []
      this.approvalFormData.ledgerAccount = ''
      if (!this.approvalFormData.mmr12) {
        return
      }
      this.getLedgerList()
    },

    // 获取总账科目
    getLedgerList () {
      this.$store.dispatch('getLedgerList', this.approvalFormData.mmr12).then(res => {
        if (res.data.resultCode === '0') {
          this.ledgerList = res.data.resultData.ledgerList
          if (this.ledgerList.length === 1) {
            this.approvalFormData.ledgerAccount = this.ledgerList[0].ledgerAccountCode
          }
        }
      })
    },

    // 获取工厂
    async getCompanyList () {
      const { vendorCode } = this.tradeApplyOrderVO.tradeApplyInfoVO
      if (vendorCode) {
        const { data } = await this.$store.dispatch('getCompanyList', { vendorCode })
        if (data.resultCode === '0') {
          this.companyList = data.resultData.companyEntityList || []
          this.companyList.forEach(item => {
            const title = `${item.entityCode}-${item.entityName}`
            this.$set(item, 'title', title)
          })
          if (this.companyList.length === 1) {
            this.approvalFormData.companyEntityCode = this.companyList[0].companyEntityCode
          }
        }
      }
    },

    // 选择所属工厂
    handleCompanyChange() {
      this.costList = []
      this.approvalFormData.costCenterCode = ''
      if (this.approvalFormData.companyEntityCode) {
        this.getCostList()
      }
    },

    // 获取成本中心
    getCostList () {
      const { companyEntityCode } = this.approvalFormData
      this.$store.dispatch('getCostList', { companyEntityCode }).then(res => {
        if (res.data.resultCode === '0') {
          this.costList = res.data.resultData.baseCostCenterList
          if (this.costList.length === 1) {
            this.approvalFormData.costCenterCode = this.costList[0].costCenterCode
          }
        }
      })
    },

    thousandSymbol (value) {
      if (value === 0) {
        return 0
      }
      if (!value) {
        return
      }
      let num = value.toString().split('.')
      let resultNum = num[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      if (num[1]) {
        resultNum = resultNum + '.' + num[1]
      }
      return resultNum
    },
    sliceOrgName (val) {
      if (!val) {
        return
      }
      let res = val.split('|')[0]
      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.block-radio {
  margin-left: $page-middle;

  .el-radio {
    margin-right: 20px;
  }

  ::v-deep .el-radio .el-radio__input {
    display: inline-block;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: $base-red;
    background: $base-red;
  }

  ::v-deep .el-radio__inner:hover {
    border-color: $base-red;
  }
}

.content-row {
  line-height: 36px;
}
</style>
